module.exports = __webpack_public_path__ + "img/banner-princiapal.8d72a6d6.png";